export default __webpack_public_path__ + "static/media/get-onboarded.b54e6275.png";